// Storage key definitions are shared with `@atlassian/global-top-navigation`.
// The navs share the dedicated collapsed key when GSN's split-storage gate is
// enabled. These constants are re-exported (rather than
// imported directly at each usage site) to keep every existing import path in
// this package working unchanged.
export {
	NAV_STATE_LS_KEY,
	DEFAULT_COLLAPSED_KEY,
	DEFAULT_WIDTH_KEY,
} from '@atlassian/navigation-common/side-nav-storage';

// Query page size for navigation items
export const DEFAULT_PAGE_SIZE = 100;
